import T from '../types';

export default toCountryId => ({
  type: T.CHANGE_DESTINATION_COUNTRY,
  toCountryId,
});
